import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue-demi';
import {
  AbSection,
  AbContainer,
  AbTitle,
  AbLink,
  AbDescription,
  AbSectionLayout,
  AbGrid,
  AbGridItem,
} from '../../ui';
import useBreakpoint from '../../../composables/useBreakpoint';
import { DEFAULT_SPACING, Spacing } from '../../../helpers/shared-props';
import { CdnImg } from '@webplatform/cdn-image';
import { TextAlign } from '../../../types';

interface Props {
  id?: string;
  title?: string;
  description?: string;
  textAlign?: TextAlign;
  items: {
    title?: string;
    link?: string;
    image?: {
      src?: string;
    };
    width?: string;
    height?: string;
    order?: number;
    orderMobile?: number;
    contentAlign?: TextAlign;
    bgGradient?: boolean;
  }[];
  spacing?: Spacing;
  disableItemsOverlay?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CardSectionGrid',
  props: {
    id: null,
    title: null,
    description: null,
    textAlign: { default: 'center' },
    items: null,
    spacing: { default: () => DEFAULT_SPACING },
    disableItemsOverlay: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { id?: string, title?: string, description?: string, textAlign: TextAlign, items: {
    title?: string;
    link?: string;
    image?: {
      src?: string;
    };
    width?: string;
    height?: string;
    order?: number;
    orderMobile?: number;
    contentAlign?: TextAlign;
    bgGradient?: boolean;
  }[], spacing: Spacing, disableItemsOverlay?: boolean };



const { isBiggerThanBreakpoint: isDesktop } = useBreakpoint('md');
const sectionItems = computed(() =>
  props.items
    .map((item, i) => {
      const order = item.order ?? i;
      const orderMobile = item.orderMobile ?? order;

      return { ...item, order, orderMobile };
    })
    .sort((a, b) =>
      isDesktop.value ? a.order - b.order : a.orderMobile - b.orderMobile
    )
);

return { __sfc: true,props, isDesktop, sectionItems, AbSection, AbContainer, AbTitle, AbLink, AbDescription, AbSectionLayout, AbGrid, AbGridItem, CdnImg }
}

})